module.exports = "/_next/static/images/e8fe0da52287de0c220d93d6c151a09e-mb-hero-lg.jpg";